<template>
    <div class="gross_profit_rate">
      <!--毛利率报表头部-->
      <div class="gp_rate_top clear">
        <input type="text" v-model="ordersNum" placeholder="订单号">
        <div class="w_percent10">
          <el-select v-model="selectStore"
                     collapse-tags
                     placeholder="店铺">
            <el-option v-for="item in storeList"
                       :key="item.id"
                       :label="item.text"
                       :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div>
          <el-select v-model="selectChannelValue"
                     placeholder="请选择渠道">
            <el-option v-for="item in channelList"
                       :key="item.id"
                       :label="item.text"
                       :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div>
          <el-select v-model="selectBrandType" placeholder="请选择品牌">
            <el-option v-for="item in brandTypeList"
                       :key="item.id"
                       :label="item.text"
                       :value="item.id">
            </el-option>
          </el-select>
        </div>
        <input type="text" v-model="goodsNum" placeholder="货号">
        <div class="w_percent8">
          <el-select v-model="selectSource" :value="selectSource" placeholder="来源">
            <el-option
              v-for="item in sourceList"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="w85">
          <el-select v-model="selectIsLosingType" placeholder="是否亏本">
            <el-option
              v-for="item in isLosingTypeList"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div>
          <el-date-picker
            v-model.trim="startTime"
            type="datetime"
            placeholder="年/月/日"
            format="yyyy/MM/dd HH:mm:ss">
          </el-date-picker>
        </div>
        <span>~</span>
        <div class="ml0">
          <el-date-picker
            v-model.trim="endTime"
            type="datetime"
            placeholder="年/月/日"
            format="yyyy/MM/dd HH:mm:ss">
          </el-date-picker>
        </div>
        <label>毛利率低于:</label>
        <input class="ml10" type="number" v-model="belowGrossMargin" placeholder="数值">

        <button class="btn_normal ml10" @click="getGrossMarginPageList()">查询</button>

        <button class="btn btn_normal fr pl10 pr10" @click="exportGrossMarginExcel()">导出查询结果</button>
      </div>

      <!--毛利率报表内容-->
      <div class="gp_rate_msg">
        <table class="table">
          <thead>
          <tr>
            <th>订单号</th>
            <th>外部订单号</th>
            <th>下单时间</th>
            <th>订单状态</th>
            <th>发货时间</th>
            <th>店铺</th>
            <th>品牌</th>
            <th>货号</th>
            <th>尺码</th>
            <th>仓库</th>
            <th>吊牌价</th>
            <th>成交单价</th>
            <th>成本折扣</th>
            <th>成本单价</th>
            <th>毛利</th>
            <th>毛利率</th>
            <th>实发数量</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in list" :key="index">
            <td>{{item.OrderId}}</td>
            <td>{{item.OutOrderId}}</td>
            <td>{{item.OrderCreateTime | time}}</td>
            <td>{{item.OrderStatusName}}</td>
            <td>{{item.OrderSendTime | time}}</td>
            <td>{{item.ShopName}}</td>
            <td>{{item.BrandName}}</td>
            <td>{{item.GoodsId}}</td>
            <td>{{item.Size}}</td>
            <td>{{item.StoreroomName}}</td>
            <td>{{item.MarketPrice}}</td>
            <td>{{item.PayUnitPrice}}</td>
            <td>{{item.CostDiscount}}</td>
            <td>{{item.CostUnitPrice}}</td>
            <td>{{item.GrossMargin}}</td>
            <td>{{item.GrossMarginRate}}</td>
            <td>{{item.SendQuantity}}</td>
          </tr>
          </tbody>
          <tbody v-if="!list.length">
          <tr>
            <td colspan="17">暂无相关信息</td>
          </tr>
          </tbody>
        </table>

        <!--分页-->
        <div class="text_right mt20" v-if="list">
          <el-pagination
            background
            :prev-text="'上一页'"
            :next-text="'下一页'"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 15, 20]"
            :page-size="pageSize"
            layout="total, prev, pager, next, sizes, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>

      <!--加载框-->
      <loading-dialog v-if="isLoading" :type="'NOP'"></loading-dialog>

      <!--信息提示框-->
      <msg-dialog v-if="isMsg"
                  :txt="txtMsg"
                  :is-suc="isSuc"
                  @closebtn="closeMsgDialog"></msg-dialog>
    </div>
</template>

<script>
  import LoadingDialog from '../../public-component/loading-dialog';
  import MsgDialog from '../../public-component/msg-dialog';

  export default {
    name: 'gross-profit-rate',
    components: {LoadingDialog, MsgDialog},
    data() {
      return {
        list: [], // 列表数据
        ordersNum: null, // 订单号
        storeList: [], // 店铺下拉
        selectStore: '', // 店铺选择
        channelList: [], // 渠道下拉列表
        selectChannelValue: '', // 选择的渠道列表
        brandTypeList: [], // 查询品牌下拉列表
        selectBrandType: '', // 选择到的查询品牌类型
        goodsNum: null, // 货号
        sourceList: [], // 来源下拉框列表
        selectSource: '', // 来源选择
        isLosingTypeList: [
          {id: null, text: '是否亏本'},
          {id: true, text: '是'},
          {id: false, text: '否'}
        ], // 是否亏本下拉列表
        selectIsLosingType: null, // 选择到的是否亏本类型
        startTime: this.Global.timeFormatStart(new Date(new Date() - 1000 * 60 * 60 * 24 )), // 开始时间
        endTime: this.Global.timeFormatEnd(new Date(new Date() - 1000 * 60 * 60 * 24 )), // 结束时间
        belowGrossMargin: null, // 毛利率
        isLoading: false, // 是否显示加载框
        isShow: false, // 提示框显示
        dialogTitle: null, // 弹出框头部名
        dialogShowType: null, // 弹出框类型
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '信息框内容', // 信息框内容
        isTip: false, // 提示框显示
        currentPage: 1, // 当前页数
        pageSize: 10, // 当前显示几条数据
        total: 0 // 总条数
      }
    },
    methods: {
      // 获取店铺下拉框信息
      getAllPXShopList() {
        this.$axios.get(this.Global.getAllPXShopList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.storeList = res.data.resData;
            this.storeList.splice(0, 0, {id: '', text: '所有店铺'});
            this.selectStore = '';
          } else {
            this.storeList = [];
            this.selectStore = res.data.errorMsg;
          }
        });
      },

      // 获取渠道下拉框信息
      getAllStoreroomsList() {
        this.$axios.get(this.Global.getAllStoreroomsList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.channelList = res.data.resData;
            this.channelList.splice(0, 0, {id: '', text: '所有渠道'});
            this.selectChannelValue = '';
          } else {
            this.channelList = [];
            this.selectChannelValue = res.data.errorMsg;
          }
        });
      },

      // 加载品牌下拉数据
      getAllBrandsList() {
        this.$axios.get(this.Global.getAllBrandsList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.brandTypeList = res.data.resData;
            this.brandTypeList.splice(0, 0, {id: '', text: '所有品牌'});
            this.selectBrandType = '';
          } else {
            this.brandTypeList = [];
            this.selectBrandType = res.data.errorMsg;
          }
        });
      },

      // 获取平台来源下拉框信息
      getOrderSourceList() {
        this.$axios.get(this.Global.getOrderSourceList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.sourceList = res.data.resData;
            this.sourceList.splice(0, 0, {id: '', text: '来源'});
            this.selectSource = '';
          } else {
            this.sourceList = [];
            this.selectSource = res.data.errorMsg;
          }
        });
      },

      // 毛利率报表 分页数据
      getGrossMarginPageList() {
        if (this.Global.timeFormatEight(this.startTime) > this.Global.timeFormatEight(this.endTime)) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '开始时间不能大于结束时间';
          return;
        }
        this.isLoading = true;
        const params = {
          OrderId: this.ordersNum,
          ShopId: this.selectStore,
          StoreroomId: this.selectChannelValue,
          BrandId: this.selectBrandType,
          GoodsId: this.goodsNum,
          OrderSource: this.selectSource,
          IsLoseMoney: this.selectIsLosingType,
          BelowGrossMargin: this.belowGrossMargin,
          BegainTime: this.Global.timeFormatEight(this.startTime),
          EndTime: this.Global.timeFormatEight(this.endTime),
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
        this.$axios.post(this.Global.getGrossMarginPageList, params).then((res) => {
          const self = this;
          let timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res) {
              if (!res.data.errorMsg.length) {
                self.list = res.data.resData.DataList;
                self.total = res.data.resData.TotalCounts;
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 100)
        });
      },

      // 毛利率报表 导出
      exportGrossMarginExcel() {
        this.isLoading = true;
        const params = {
          OrderId: this.ordersNum,
          ShopId: this.selectStore,
          StoreroomId: this.selectChannelValue,
          BrandId: this.selectBrandType,
          GoodsId: this.goodsNum,
          OrderSource: this.selectSource,
          IsLoseMoney: this.selectIsLosingType,
          BelowGrossMargin: this.belowGrossMargin,
          BegainTime: this.Global.timeFormatEight(this.startTime),
          EndTime: this.Global.timeFormatEight(this.endTime),
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
        this.$axios.post(this.Global.exportGrossMarginExcel, params).then((res) => {
          const self = this;
          let timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res.data) {
              if (!res.data.errorMsg.length) {
                window.open(res.data.resData, '_blank')
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 100);
        });
      },

      // 分页——当前页面显示条数改变
      handleSizeChange(val) {
        this.pageSize = val;
        this.getGrossMarginPageList();
      },

      // 分页——当前页改变
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getGrossMarginPageList();
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
      }
    },
    created() {
      this.getAllPXShopList();
      this.getAllStoreroomsList();
      this.getAllBrandsList();
      this.getOrderSourceList();
      this.getGrossMarginPageList();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .gross_profit_rate {
    background-color: #ffffff;
    height: 100%;
    position: relative;

    .gp_rate_top {
      padding: 10px 10px 0 0;

      .w85 {
        width: 85px;
      }

      input[type='text'], & > div {
        margin-left: 10px;
        display: inline-block;
        width: 130px;
        margin-bottom: 10px;
      }

      input[type='number'] {
        width: 50px;
        height: 30px;
        line-height: 30px;
        padding: 0 0 0 5px;
        border: 1px solid #eee;
        border-radius: 0;
        -webkit-box-shadow: none;
        box-shadow: none;
        background-color: #fff;
      }
    }

    .gp_rate_msg {
      height: calc(100% - 118px);
      margin: 10px 10px 0;
      overflow: auto;

      th, td {
        border: 1px solid #ddd;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/report-management/gross-profit-rate.vue